<ul>
  <li>
    <p>
      Yearly Maximum Pensionable Earnings (YMPE) are projected to increase at a
      rate of {{assumptions.ympeProjectionRate}}% per annum.
    </p>
  </li>
  <li>
    <p>
      Income Tax Act pension limits are projected to increase at a rate of {{assumptions.itaProjectionRate}}%
      per annum.
    </p>
  </li>
  <li>
    <p>
      Canada Pension Plan and Old Age Security amounts are projected to increase
      at a rate of {{assumptions.cppOasProjectionRate}}% per annum.
    </p>
  </li>
  <li><p>Inflation is assumed to increase at {{assumptions.inflationRate}}% per annum.</p></li>
  <li><p>The going concern discount rate is {{assumptions.discountRate}}% per annum.</p></li>
  <li>
    <p>
      Mortality is based on 90% of the 2014 Canadian Pensioners’ Mortality table with
      generational projection using projection scale CPM-B.
    </p>
  </li>
</ul>
